import React, { useMemo } from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import RegisterImage from "../assets/images/Login_Image.jpg";
import ForgetPasswordImage from "../assets/images/forgot-password.jpg";
import ResetPasswordImage from "../assets/images/reset-password.jpg";
import { useStore } from "store/zustand";
import { useUserStore } from "store/userStore";

import { isAdminRole } from "utils/roles";

interface AuthLayoutProps {
  children?: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const location = useLocation();
  const { isAuthenticated } = useStore();
  const role = useUserStore((state) => state.role);

  const imageInfo = useMemo(() => {
    if (location.pathname.includes("setNewPassword")) {
      return { src: ResetPasswordImage, alt: "Reset Password" };
    }
    if (location.pathname.includes("forgetPassword")) {
      return { src: ForgetPasswordImage, alt: "Forgot Password" };
    }
    return { src: RegisterImage, alt: "Register" };
  }, [location.pathname]);

  if (isAuthenticated) {
    if (isAdminRole(role)) {
      return <Navigate to="/admin/dashboard" replace />;
    }
    return <Navigate to="/search" replace />;
  }

  return (
    <div className="grid grid-cols-12 lg:gap-0 gap-6 items-center p-8">
      <div className="lg:col-span-7 col-span-12 sm:block">
        <img
          src={imageInfo.src}
          alt={imageInfo.alt}
          className="w-full h-auto"
        />
      </div>
      {children || <Outlet />}
    </div>
  );
};

export default AuthLayout;
